<div>
    <label for="state">State Context Path</label>
    <rules-editor [(rule)]="stateRule" [placeholder]="'State Path'" (updateRule)="ruleCompiled($event, 'state')"></rules-editor>

    <label for="county">County Context Path</label>
    <rules-editor [(rule)]="countyRule" [placeholder]="'County Path'" (updateRule)="ruleCompiled($event, 'county')"></rules-editor>

    <label for="uniqueWellIdentifier">Unique Well Identifier</label>
    <rules-editor [(rule)]="uniqueWellIdentifierRule" [placeholder]="'If left empty, will be generated.'" (updateRule)="ruleCompiled($event, 'uniqueWellIdentifier')"></rules-editor>

    <label for="sideTrack">Side Track Context Path</label>
    <rules-editor [(rule)]="sideTrackRule" [placeholder]="'Side Track Path (leave blank for new well)'" (updateRule)="ruleCompiled($event, 'sideTrack')"></rules-editor>

    <label for="state">Sequence Code Context Path</label>
    <rules-editor [(rule)]="seqCodeRule" [placeholder]="'Sequence Code Path (leave blank for new well)'" (updateRule)="ruleCompiled($event, 'sequenceCode')"></rules-editor>

    <label for="state">Save Location Path</label>
    <input type="text" id="state" placeholder="Save Location" [(ngModel)]="config.saveLocationPath" />
</div>